export { default, type FooterData } from './Footer';
